import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>SCE Automated</h3>
            <p>Professional automation and industrial control solutions for manufacturing excellence.</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><Link to="/industries">Industries</Link></li>
              <li><Link to="/clients">Clients</Link></li>
              <li><Link to="/careers">Careers</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: <a href="mailto:Contact@sce-automated-us.com">Contact@sce-automated-us.com</a></p>
            <p>Phone (USA): <a href="tel:+19152162182">915 216 2182</a></p>
            <p style={{marginTop: '10px'}}>221 N Kansas St Ste 700</p>
            <p>El Paso, Texas 79901-1443</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} SCE Automated. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

